package com.hyperether.goodjob.scenes.jobs

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ExperimentalLayoutApi
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.lazy.LazyRow
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.selection.DisableSelection
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.Checkbox
import androidx.compose.material.CheckboxDefaults
import androidx.compose.material.Divider
import androidx.compose.material.IconButton
import androidx.compose.material.MaterialTheme
import androidx.compose.material.Text
import androidx.compose.material.TextButton
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.MoreVert
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.Icon
import androidx.compose.material3.OutlinedTextField
import androidx.compose.material3.OutlinedTextFieldDefaults
import androidx.compose.runtime.Composable
import androidx.compose.runtime.MutableState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.draw.scale
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.painter.BitmapPainter
import androidx.compose.ui.graphics.painter.Painter
import androidx.compose.ui.input.pointer.PointerIcon
import androidx.compose.ui.input.pointer.pointerHoverIcon
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import androidx.compose.ui.window.Dialog
import com.hyperether.goodjob.boxCornerShape
import com.hyperether.goodjob.containerSizeDp
import com.hyperether.goodjob.getPlatformChecker
import com.hyperether.goodjob.log
import com.hyperether.goodjob.models.Contact
import com.hyperether.goodjob.models.Job
import com.hyperether.goodjob.models.Note
import com.hyperether.goodjob.repository.remote.model.FileObject
import com.hyperether.goodjob.resources.Res
import com.hyperether.goodjob.resources.add_file
import com.hyperether.goodjob.resources.add_note
import com.hyperether.goodjob.resources.add_note_here
import com.hyperether.goodjob.resources.are_you_sure_note
import com.hyperether.goodjob.resources.cancel
import com.hyperether.goodjob.resources.confirmation
import com.hyperether.goodjob.resources.contact_and_site_details
import com.hyperether.goodjob.resources.contact_name
import com.hyperether.goodjob.resources.contact_person
import com.hyperether.goodjob.resources.deadline_and_duration
import com.hyperether.goodjob.resources.delete
import com.hyperether.goodjob.resources.documents
import com.hyperether.goodjob.resources.due_date
import com.hyperether.goodjob.resources.email_capital
import com.hyperether.goodjob.resources.enter_text
import com.hyperether.goodjob.resources.file_empty
import com.hyperether.goodjob.resources.files
import com.hyperether.goodjob.resources.images
import com.hyperether.goodjob.resources.job_schedule
import com.hyperether.goodjob.resources.newest
import com.hyperether.goodjob.resources.note_empty
import com.hyperether.goodjob.resources.notes
import com.hyperether.goodjob.resources.ok
import com.hyperether.goodjob.resources.oldest
import com.hyperether.goodjob.resources.phone
import com.hyperether.goodjob.resources.round_check_box
import com.hyperether.goodjob.resources.selected
import com.hyperether.goodjob.resources.sort_by
import com.hyperether.goodjob.resources.start_date
import com.hyperether.goodjob.resources.status_check_icon
import com.hyperether.goodjob.resources.time
import com.hyperether.goodjob.resources.trash
import com.hyperether.goodjob.scenes.addNew.DropdownSortBy
import com.hyperether.goodjob.scenes.components.CircleWithInitial
import com.hyperether.goodjob.scenes.components.NoteEditDialog
import com.hyperether.goodjob.scenes.components.PopUpDialog
import com.hyperether.goodjob.scenes.components.clickableWithPointer
import com.hyperether.goodjob.scenes.components.disableMouseDragScrollOnWeb
import com.hyperether.goodjob.scenes.components.pointerCursorIfEnabled
import com.hyperether.goodjob.scenes.components.verticalScrollbar
import com.hyperether.goodjob.scenes.register.FilledButton
import com.hyperether.goodjob.theme.BlueApp
import com.hyperether.goodjob.theme.BorderColor
import com.hyperether.goodjob.theme.GrayBackgroundDivider
import com.hyperether.goodjob.theme.Green
import com.hyperether.goodjob.theme.InputBorderColor
import com.hyperether.goodjob.theme.TextColor
import com.hyperether.goodjob.util.DateTimeUtil
import com.hyperether.goodjob.util.StatusColor
import com.hyperether.goodjob.util.toScaleDp
import com.hyperether.goodjob.util.toScaleSp
import com.hyperether.resources.stringResource
import org.jetbrains.compose.resources.painterResource

@Composable
fun EditJobsDialog(
    showDialog: Boolean, jobs: List<Job>,
    onDelete: () -> Unit,
    onExportList: () -> Unit,
    onImportList: () -> Unit,
    isEmployee: Boolean
) {
    if (showDialog) {
        Box(
            modifier = Modifier
                .width(300.toScaleDp())
                .clickable(
                    indication = null,
                    interactionSource = remember { MutableInteractionSource() },
                    onClick = { }
                )
                .padding(16.toScaleDp())
                .background(Color.White, shape = RoundedCornerShape(8.toScaleDp()))
        ) {
            Column {
                Text(
                    text = "${jobs.size} " + stringResource(Res.string.selected),
                    fontWeight = FontWeight.Bold,
                    fontSize = 16.toScaleSp(),
                    modifier = Modifier.padding(
                        start = 16.toScaleDp(),
                        end = 16.toScaleDp(),
                        top = 16.toScaleDp()
                    )
                )

                Spacer(modifier = Modifier.height(8.toScaleDp()))

                Divider(
                    color = Color.LightGray,
                    thickness = 1.toScaleDp()
                )

                Spacer(modifier = Modifier.height(8.toScaleDp()))

                Row(
                    horizontalArrangement = Arrangement.SpaceBetween,
                    modifier = Modifier.fillMaxWidth()
                        .padding(
                            start = 16.toScaleDp(),
                            end = 16.toScaleDp(),
                            bottom = 16.toScaleDp()
                        )
                        .clickable {
                            onDelete()
                        }
                ) {
                    if (!isEmployee) {
                        Text(
                            text = stringResource(Res.string.delete),
                            fontSize = 14.toScaleSp(),
                            color = Color.Red
                        )
                    }
//                    Text(
//                        text = stringResource(Res.string.export_list),
//                        fontSize = Sp(14f),
//                        color = BlueApp,
//                        modifier = Modifier.clickable {
//                            onExportList()
//                        })
//                    Text(
//                        text = stringResource(Res.string.import_list),
//                        fontSize = Sp(14f),
//                        color = BlueApp,
//                        modifier = Modifier.clickable {
//                            onImportList()
//                        })
                }
            }
        }
    }
}

@Composable
fun ImageCard(imageDescription: String) {
    Box(
        modifier = Modifier
            .height((150.toScaleDp()))
            .clip(RoundedCornerShape(8.toScaleDp()))
            .background(Color.LightGray),
        contentAlignment = Alignment.Center
    ) {
        Text(text = imageDescription, color = Color.Gray)
    }
}

@Composable
fun SectionTitle(title: String) {
    Text(
        text = title,
        fontSize = 20.toScaleSp(),
        fontWeight = FontWeight.W700,
        modifier = Modifier.padding(vertical = 8.toScaleDp())
    )
}

@Composable
fun CheckBoxItem(
    question: String,
    answer: String
) {
    Column {
        Text(text = question, fontSize = 14.toScaleSp(), color = Color.Black)
        Row(
            verticalAlignment = Alignment.CenterVertically,
            modifier = Modifier.padding(vertical = 4.toScaleDp())
        ) {
            Icon(
                painter = painterResource(Res.drawable.round_check_box),
                modifier = Modifier.size(25.toScaleDp()),
                contentDescription = null,
                tint = Green
            )

            Spacer(modifier = Modifier.width(8.toScaleDp()))
            Text(
                text = answer,
                fontSize = 14.toScaleSp(),
                color = Color.Black,
                fontWeight = FontWeight.Bold
            )
        }
    }
}

@Composable
fun IssueReportView(
    answer: String
) {
    Row(
        verticalAlignment = Alignment.CenterVertically,
        modifier = Modifier.padding(vertical = 4.toScaleDp())
    ) {
        Icon(
            painter = painterResource(Res.drawable.status_check_icon),
            modifier = Modifier.size(25.toScaleDp()),
            contentDescription = null,
            tint = Color.Unspecified
        )
        Spacer(modifier = Modifier.width(8.toScaleDp()))
        Text(
            text = answer,
            fontSize = 14.toScaleSp(),
            color = Color.Black,
            fontWeight = FontWeight.Bold
        )
    }
}

@Composable
fun CheckBoxItemBoldTitle(
    question: String,
    answer: String,
    checked: Boolean,
    onCheckedChange: (Boolean) -> Unit
) {
    Column {
        Text(text = question, style = MaterialTheme.typography.h6, fontSize = 16.toScaleSp())
        Row(verticalAlignment = Alignment.CenterVertically) {
            Checkbox(
                modifier = Modifier.scale(1.toScaleDp().value),
                checked = checked,
                onCheckedChange = onCheckedChange,
                colors = CheckboxDefaults.colors(checkedColor = Green)
            )
            Spacer(modifier = Modifier.width(8.toScaleDp()))
            Text(text = answer, style = MaterialTheme.typography.body1, color = Color.Gray)
        }
    }
}

@Composable
fun CheckBoxMultipleItemBoldTitle(
    question: String,
    answerList: List<String>,
    checkedList: List<Boolean>,
    onSelectedAnswer: (Int) -> Unit
) {
    Column {
        Text(
            text = question,
            fontWeight = FontWeight.W700,
            fontSize = 16.toScaleSp()
        )
        for (answer in answerList) {
            Row(verticalAlignment = Alignment.CenterVertically) {
                Checkbox(
                    checked = checkedList[answerList.indexOf(answer)],
                    onCheckedChange = {
                        onSelectedAnswer(answerList.indexOf(answer))
                    },
                    colors = CheckboxDefaults.colors(
                        checkedColor = Green,
                        uncheckedColor = Color.Gray,
                        checkmarkColor = Color.White
                    ),
                    modifier = Modifier.scale(1.toScaleDp().value)
                )
                Spacer(modifier = Modifier.width(8.toScaleDp()))
                Text(text = answer, fontSize = 16.toScaleSp(), color = Color.Gray)
            }
        }
    }
}

@OptIn(ExperimentalLayoutApi::class)
@Composable
fun NotesAndDocumentsView(
    isWebView: Boolean = false,
    images: List<Pair<FileObject, BitmapPainter>>,
    documents: List<Pair<FileObject, String>>,
    job: Job,
    isEmployee: Boolean,
    onAddNoteClick: () -> Unit,
    onOpenPdfClick: (String) -> Unit,
    onDeleteFileClick: (String) -> Unit,
    onDeleteImageClick: (String) -> Unit,
    onMenuClicked: (Note) -> Unit,
    onEditNote: (Note) -> Unit,
    onDeleteNote: (Note) -> Unit,
    isPopupVisible: (Note) -> Boolean,
    onAddFileClick: (String) -> Unit,
    onOpenImageClick: (Painter) -> Unit,
) {
    log.d("NotesAndDocumentsView") { "NotesAndDocumentsView recompose. notes:${job.noteObjects?.size} documents: ${documents.size}" }
    val sortBy = remember { mutableStateOf<String?>(null) }
    val sortOptions = listOf(
        stringResource(Res.string.newest),
        stringResource(Res.string.oldest)
    )

    Column(modifier = Modifier.padding(horizontal = 16.toScaleDp())) {
        // Notes Section
        Spacer(modifier = Modifier.height(24.toScaleDp()))
        NotesAndDocumentsSectionHeader(
            isSortByVisible = isWebView,
            sortBy = sortBy,
            items = sortOptions,
            title = stringResource(Res.string.notes),
            actionText = stringResource(Res.string.add_note),
            onAddNoteClick = { onAddNoteClick() },
            onSortChange = {
                sortBy.value = it
            }
        )
        job.noteObjects?.let { noteList ->
            log.d("NotesAndDocumentsView") { "NotesAndDocumentsView recompose. notes:${noteList.size}" }
            if (noteList.isNotEmpty()) {
                var filteredNotes = noteList.filter { it.noteText?.isNotBlank() == true }
                filteredNotes = when (sortBy.value) {
                    stringResource(Res.string.newest) -> filteredNotes.sortedByDescending { it.createdAt }
                    stringResource(Res.string.oldest) -> filteredNotes.sortedBy { it.createdAt }
                    else -> filteredNotes
                }
                if (filteredNotes.isNotEmpty()) {
                    Spacer(modifier = Modifier.height(12.toScaleDp()))
                    if (!isWebView) {
                        Column(
                            modifier = Modifier
                                .fillMaxWidth(),
                            verticalArrangement = Arrangement.spacedBy(8.toScaleDp())
                        ) {
                            filteredNotes.forEach { note ->
                                NoteRow(
                                    note = note,
                                    isPopupVisible = isPopupVisible(note),
                                    onMenuClicked = {
                                        onMenuClicked(note)
                                    },
                                    onEdit = {
                                        onEditNote(note)
                                    },
                                    onDelete = {
                                        onDeleteNote(note)
                                    }
                                )
                                Spacer(modifier = Modifier.height(4.toScaleDp()))
                            }
                        }
                    } else {
                        FlowRow(
                            modifier = Modifier.fillMaxWidth(),
                            horizontalArrangement = Arrangement.spacedBy(24.toScaleDp()),
                            verticalArrangement = Arrangement.spacedBy(24.toScaleDp())
                        ) {
                            filteredNotes.forEach { note ->
                                Box(
                                    modifier = Modifier
                                        .width(350.toScaleDp())
                                        .heightIn(max = 350.toScaleDp())
                                ) {
                                    NoteRow(
                                        isWebView = true,
                                        note = note,
                                        isPopupVisible = isPopupVisible(note),
                                        onMenuClicked = { onMenuClicked(note) },
                                        onEdit = { onEditNote(note) },
                                        onDelete = { onDeleteNote(note) }
                                    )
                                }
                            }
                        }
                    }
                }
            } else {
                Spacer(modifier = Modifier.height(12.toScaleDp()))
                Text(
                    text = stringResource(Res.string.note_empty),
                    fontSize = 16.toScaleSp(),
                    textAlign = TextAlign.Center
                )
            }
        } ?: run {
            Spacer(modifier = Modifier.height(12.toScaleDp()))
            Text(
                text = stringResource(Res.string.note_empty),
                fontSize = 16.toScaleSp(),
                textAlign = TextAlign.Center
            )
        }
        Spacer(modifier = Modifier.height(16.toScaleDp()))

        // Document Section
        NotesAndDocumentsSectionHeader(
            isSortByVisible = false,
            sortBy = null,
            items = null,
            title = if (getPlatformChecker().isMobile()) stringResource(Res.string.documents) else stringResource(
                Res.string.files
            ),
            actionText = stringResource(Res.string.add_file),
            isAddButtonVisible = true,
            onAddNoteClick = {
                job.id?.let { onAddFileClick(it) }
            },
            onSortChange = {}
        )
        log.d("FILES") { "NotesAndDocumentsView recompose. documents: ${documents.size}" }
        if (documents.isNotEmpty()) {
            Spacer(modifier = Modifier.height(24.toScaleDp()))
            Column(verticalArrangement = Arrangement.spacedBy(8.toScaleDp())) {
                if (getPlatformChecker().isMobile()) {
                    documents.forEach { (fileObject, filePath) ->
                        DocumentRow(
                            isEmployee = isEmployee,
                            documentName = fileObject.documentFileId
                                ?: filePath.substringAfterLast("/"),
                            author = fileObject.createdBy.orEmpty(),
                            date = fileObject.createdAt ?: "",
                            openPdf = { onOpenPdfClick(filePath) },
                            onDeleteFileClick = {
                                onDeleteFileClick(
                                    fileObject.documentFileId ?: ""
                                )
                            }
                        )
                    }
                } else {
                    Text(
                        text = stringResource(Res.string.documents),
                        style = MaterialTheme.typography.h6,
                        fontWeight = FontWeight.Bold,
                        fontSize = 16.toScaleSp()
                    )

                    documents.forEach { (fileObject, filePath) ->
                        DocumentRowWeb(
                            documentName = fileObject.documentFileId
                                ?: filePath.substringAfterLast("/"),
                            author = fileObject.createdBy.orEmpty(),
                            date = fileObject.createdAt ?: "",
                            openPdf = { onOpenPdfClick(filePath) },
                            onDeleteFileClick = {
                                onDeleteFileClick(
                                    fileObject.documentFileId ?: ""
                                )
                            }
                        )
                    }
                }
            }
        } else {
            Spacer(modifier = Modifier.height(12.toScaleDp()))
            Text(
                text = stringResource(Res.string.file_empty),
                fontSize = 16.toScaleSp(),
                textAlign = TextAlign.Center
            )
        }
        Spacer(modifier = Modifier.height(32.toScaleDp()))

        // Images Section
        if (images.isNotEmpty()) {
            NotesAndDocumentsSectionHeader(
                isSortByVisible = false,
                sortBy = null,
                items = null,
                title = stringResource(Res.string.images),
                actionText = "",
                onAddNoteClick = {},
                onSortChange = {}
            )
            Spacer(modifier = Modifier.height(11.toScaleDp()))
            if (!getPlatformChecker().isMobile()) {
                FlowRow(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.spacedBy(16.toScaleDp()),
                    verticalArrangement = Arrangement.spacedBy(16.toScaleDp())
                ) {
                    for ((fileObject, imagePainter) in images) {
                        Column(
                            modifier = Modifier.width(200.toScaleDp())
                        ) {
                            ImageRow(
                                imageName = fileObject.documentFileId.orEmpty(),
                                imagePainter = imagePainter,
                                onDeleteImageClick = {
                                    onDeleteImageClick(fileObject.documentFileId ?: "")
                                },
                                onOpenImageClick = { painter ->
                                    onOpenImageClick(painter)
                                }
                            )
                        }
                    }
                }
            } else {
                FlowRow(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.SpaceEvenly,
                    verticalArrangement = Arrangement.spacedBy(8.toScaleDp())
                ) {
                    for ((fileObject, imagePainter) in images) {
                        ImageRow(
                            imageName = fileObject.documentFileId.orEmpty(),
                            imagePainter = imagePainter,
                            imageWidth = (containerSizeDp.value.value * 0.4).toInt(),
                            onDeleteImageClick = {
                                onDeleteImageClick(fileObject.documentFileId ?: "")
                            },
                            onOpenImageClick = { painter ->
                                onOpenImageClick(painter)
                            }
                        )
                    }
                }
            }
            Spacer(modifier = Modifier.height(16.toScaleDp()))
        }
    }
}

@Composable
fun NotesAndDocumentsSectionHeader(
    isSortByVisible: Boolean = false,
    sortBy: MutableState<String?>?,
    items: List<String>?,
    title: String,
    actionText: String,
    onAddNoteClick: () -> Unit,
    onSortChange: (String) -> Unit,
    isAddButtonVisible: Boolean = true
) {
    Row(
        modifier = Modifier.fillMaxWidth(),
        horizontalArrangement = Arrangement.SpaceBetween,
        verticalAlignment = Alignment.CenterVertically
    ) {
        Text(
            text = title,
            color = Color.Black,
            fontWeight = FontWeight.W900,
            fontSize = 27.toScaleSp(),
            maxLines = 1,
            overflow = TextOverflow.Ellipsis
        )
        Row(
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(8.toScaleDp())
        ) {
            if (actionText.isNotEmpty() && isAddButtonVisible) {
                if (getPlatformChecker().isMobile()) {
                    Text(
                        text = actionText,
                        color = BlueApp,
                        style = MaterialTheme.typography.body1,
                        modifier = Modifier.border(
                            1.toScaleDp(),
                            BlueApp,
                            RoundedCornerShape(12.toScaleDp())
                        )
                            .padding(horizontal = 12.toScaleDp(), vertical = 10.toScaleDp())
                            .clickable {
                                onAddNoteClick()
                            },
                        maxLines = 1,
                        overflow = TextOverflow.Ellipsis
                    )
                } else {
                    FilledButton(
                        onClick = {
                            onAddNoteClick()
                        },
                        text = actionText,
                        isEnabled = true,
                        modifier = Modifier.width(150.toScaleDp())
                    )
                }
            }
            val sortByString = stringResource(Res.string.sort_by)
            if (isSortByVisible) {
                DisableSelection {
                    DropdownSortBy(
                        shouldAppendSortBy = false,
                        items = items ?: emptyList(),
                        selectedValue = if (!sortBy?.value.isNullOrEmpty()) sortBy?.value else items?.get(
                            0
                        ),
                        onValueSelected = { selectedSort ->
                            sortBy?.value = selectedSort
                            selectedSort?.let { onSortChange(it) }
                        },
                        displayText = { it ?: sortByString },
                        placeholderColor = BorderColor,
                        textColor = Color.Black,
                        modifier = Modifier.height(55.toScaleDp())
                    )
                }
            }
        }
    }
}

@Composable
fun NoteRow(
    isWebView: Boolean = false,
    note: Note,
    isPopupVisible: Boolean,
    onMenuClicked: (Note) -> Unit,
    onEdit: () -> Unit,
    onDelete: () -> Unit
) {
    val scrollState = rememberScrollState()
    val baseModifier = if (isWebView) {
        Modifier
            .fillMaxWidth()
            .verticalScrollbar(scrollState)
            .disableMouseDragScrollOnWeb()
    } else {
        Modifier
            .fillMaxWidth()
    }

    Box(
        modifier = Modifier
            .fillMaxWidth()

    ) {
        Column(
            modifier = baseModifier
                .border(1.toScaleDp(), BorderColor, boxCornerShape())
                .padding(16.toScaleDp())
        ) {
            Row(
                horizontalArrangement = Arrangement.SpaceBetween,
                verticalAlignment = Alignment.Top,
                modifier = Modifier.fillMaxWidth()
            ) {
                Text(
                    text = note.noteText.orEmpty(),
                    style = MaterialTheme.typography.body1,
                    fontSize = 14.toScaleSp(),
                    lineHeight = 16.toScaleSp(),
                    modifier = Modifier
                        .weight(1f)
                        .then(
                            if (isWebView) Modifier.heightIn(max = 200.toScaleDp())
                                .verticalScroll(scrollState)
                                .disableMouseDragScrollOnWeb() else Modifier
                        ),
                    overflow = TextOverflow.Ellipsis
                )
                Icon(
                    imageVector = Icons.Default.MoreVert,
                    contentDescription = "Menu",
                    modifier = Modifier.size(24.toScaleDp())
                        .clickableWithPointer {
                            onMenuClicked(note)
                        },
                    tint = Color(0xFF605E5E)
                )
            }
            Spacer(modifier = Modifier.height(16.toScaleDp()))
            if (!isWebView) {
                Row(
                    horizontalArrangement = Arrangement.SpaceBetween,
                    modifier = Modifier.fillMaxWidth(),
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    Row(
                        verticalAlignment = Alignment.CenterVertically,
                        modifier = Modifier.weight(1f)
                    ) {
                        CircleWithInitial(note.createdBy.orEmpty())
                        Spacer(modifier = Modifier.width(8.toScaleDp()))
                        Text(
                            text = note.createdBy.orEmpty(),
                            maxLines = 1,
                            fontSize = 14.toScaleSp(),
                            overflow = TextOverflow.Ellipsis,
                            style = MaterialTheme.typography.body2,
                            color = Color(0xFF484646),
                            modifier = Modifier.weight(1f)
                        )
                    }
                    Text(
                        text = note.createdAt.orEmpty(),
                        style = MaterialTheme.typography.body2,
                        color = Color.Gray,
                        maxLines = 1,
                        fontSize = 14.toScaleSp(),
                        overflow = TextOverflow.Ellipsis
                    )
                }
            } else {
                Column(
                    modifier = Modifier.fillMaxWidth()
                ) {
                    Text(
                        text = note.createdAt.orEmpty(),
                        style = MaterialTheme.typography.body2,
                        color = Color.Gray,
                        lineHeight = 16.toScaleSp(),
                        maxLines = 1,
                        fontSize = 14.toScaleSp(),
                        overflow = TextOverflow.Ellipsis
                    )
                    Spacer(modifier = Modifier.height(8.toScaleDp()))
                    Row(
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        CircleWithInitial(size = 25.toScaleDp(), name = note.createdBy.orEmpty())
                        Spacer(modifier = Modifier.width(8.toScaleDp()))
                        Text(
                            text = note.createdBy.orEmpty(),
                            style = MaterialTheme.typography.body2,
                            color = Color(0xFF484646),
                            maxLines = 1,
                            fontSize = 14.toScaleSp(),
                            overflow = TextOverflow.Ellipsis
                        )
                    }

                }
            }
        }
        if (isPopupVisible) {
            Box(
                modifier = Modifier
                    .align(Alignment.TopEnd)
            ) {
                NoteEditDialog(
                    onDelete = onDelete,
                    onEdit = onEdit
                )
            }
        }
    }
}

@Composable
fun DocumentRow(
    documentName: String,
    author: String,
    date: String,
    isEmployee: Boolean,
    openPdf: () -> Unit,
    onDeleteFileClick: (String) -> Unit,
    isOverview: Boolean = false
) {
    Column {
        Row(
            horizontalArrangement = Arrangement.SpaceBetween,
            verticalAlignment = Alignment.CenterVertically,
            modifier = Modifier.fillMaxWidth()
        ) {
            Text(
                text = documentName,
                color = BlueApp,
                style = MaterialTheme.typography.body1,
                maxLines = 1,
                overflow = TextOverflow.Ellipsis,
                modifier = Modifier
                    .weight(1f)
                    .padding(end = 8.toScaleDp())
                    .clickable { openPdf() }
            )
            if (!isOverview) {
                DisableSelection {
                    Image(
                        painter = painterResource(Res.drawable.trash),
                        contentDescription = null,
                        modifier = Modifier
                            .size(20.toScaleDp())
                            .clickable {
                                onDeleteFileClick(documentName)
                            }
                    )
                }
            }
        }
        if (!isOverview) {
            Spacer(modifier = Modifier.height(2.toScaleDp()))
            Row(
                horizontalArrangement = Arrangement.SpaceBetween,
                modifier = Modifier.fillMaxWidth()
            ) {
                Text(
                    text = author,
                    style = MaterialTheme.typography.body2,
                    color = Color.Gray
                )
                Text(
                    text = date,
                    style = MaterialTheme.typography.body2,
                    color = Color.Gray
                )
            }
        }
    }
}

@Composable
fun DocumentRowWeb(
    documentName: String,
    author: String,
    date: String,
    openPdf: () -> Unit,
    onDeleteFileClick: (String) -> Unit,
    isOverview: Boolean = false
) {
    val space = 40.toScaleDp()
    Column(
        modifier = Modifier.fillMaxWidth(),
    ) {
        Row(
            horizontalArrangement = Arrangement.SpaceBetween,
            verticalAlignment = Alignment.CenterVertically,
            modifier = Modifier.fillMaxWidth().padding(bottom = 8.toScaleDp())
        ) {
            Text(
                text = documentName,
                color = BlueApp,
                style = MaterialTheme.typography.body1,
                maxLines = 1,
                fontSize = 14.toScaleSp(),
                overflow = TextOverflow.Ellipsis,
                modifier = Modifier
                    .weight(2f)
                    .clickable { openPdf() }
            )
            if (!isOverview) {
                Spacer(modifier = Modifier.width(space))
                Text(
                    modifier = Modifier.weight(1f),
                    text = date,
                    fontSize = 14.toScaleSp(),
                    style = MaterialTheme.typography.body2,
                    color = Color.Gray
                )
                Spacer(modifier = Modifier.width(space))
                Row(
                    modifier = Modifier.weight(1f),
                    horizontalArrangement = Arrangement.Start
                ) {
                    CircleWithInitial(name = author, size = 20.toScaleDp(), fontSize = 12)
                    Spacer(modifier = Modifier.width(8.toScaleDp()))
                    Text(
                        text = author,
                        fontSize = 14.toScaleSp(),
                        style = MaterialTheme.typography.body2,
                        color = Color.Gray,
                    )
                }
                Spacer(modifier = Modifier.width(space))
                DisableSelection {
                    Image(
                        painter = painterResource(Res.drawable.trash),
                        contentDescription = null,
                        modifier = Modifier
                            .size(20.toScaleDp())
                            .clickable {
                                onDeleteFileClick(documentName)
                            }
                    )
                }
            }
        }
        Divider(modifier = Modifier.fillMaxWidth(), color = BorderColor)
    }
}

@Composable
fun ImageRow(
    isDeleteVisible: Boolean = true,
    imageName: String? = null,
    imagePainter: Painter?,
    onDeleteImageClick: (String) -> Unit = {},
    imageWidth: Int? = null,
    onOpenImageClick: (Painter) -> Unit
) {
    Column {
        if (imagePainter != null) {
            if (imageWidth != null) {
                Image(
                    painter = imagePainter,
                    contentDescription = null,
                    contentScale = ContentScale.Crop,
                    modifier = Modifier
                        .size(imageWidth.toFloat().toScaleDp())
                        .clip(RoundedCornerShape(8.toScaleDp()))
                        .clickableWithPointer {
                            onOpenImageClick(imagePainter)
                        }
                )
            } else {
                Image(
                    painter = imagePainter,
                    contentDescription = null,
                    contentScale = ContentScale.Crop,
                    modifier = Modifier
                        .size(190.toScaleDp())
                        .clip(RoundedCornerShape(8.toScaleDp()))
                        .clickableWithPointer {
                            onOpenImageClick(imagePainter)
                        }
                )
            }
        }
        Spacer(modifier = Modifier.height(4.toScaleDp()))
        Row(
            verticalAlignment = Alignment.CenterVertically,
            modifier = if (imageWidth == null) Modifier
                .fillMaxWidth()
                .padding(end = 8.toScaleDp())
            else
                Modifier.width(imageWidth.toFloat().toScaleDp())
        ) {
            imageName?.let {
                Text(
                    text = imageName,
                    style = MaterialTheme.typography.body2,
                    color = Color.Gray,
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis,
                    modifier = Modifier.weight(1f)
                )
                Spacer(modifier = Modifier.width(14.toScaleDp()))
                if (isDeleteVisible) {
                    DisableSelection {
                        Image(
                            painter = painterResource(Res.drawable.trash),
                            contentDescription = null,
                            modifier = Modifier
                                .clip(boxCornerShape())
                                .size(20.toScaleDp())
                                .clickableWithPointer {
                                    onDeleteImageClick(imageName)
                                }
                        )
                    }
                }
            }
        }
    }
}

@Composable
fun NoteInputDialog(
    initialText: MutableState<String>,
    onDismiss: () -> Unit,
    onConfirm: () -> Unit
) {
    val initialTextCheck by remember { mutableStateOf(initialText.value) }

    Dialog(onDismissRequest = {
        onDismiss()
        initialText.value = ""
    }) {
        Box(
            modifier = Modifier
                .fillMaxWidth()
                .padding(16.toScaleDp())
                .clip(RoundedCornerShape(16.toScaleDp()))
                .background(Color.White)
        ) {
            Column(
                modifier = Modifier.padding(16.toScaleDp()),
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                Text(
                    text = stringResource(Res.string.add_note_here),
                    fontSize = 20.toScaleSp(),
                    color = BlueApp,
                    fontWeight = FontWeight.Bold,
                    modifier = Modifier.padding(bottom = 8.toScaleDp())
                )
                OutlinedTextField(
                    value = initialText.value,
                    onValueChange = { initialText.value = it },
                    textStyle = TextStyle(fontSize = 14.toScaleSp()),
                    label = {
                        Text(
                            stringResource(Res.string.enter_text),
                            fontSize = 14.toScaleSp()
                        )
                    },
                    modifier = Modifier
                        .fillMaxWidth()
                        .padding(bottom = 16.toScaleDp())
                        .weight(1f, fill = false),
                    colors = OutlinedTextFieldDefaults.colors(
                        disabledBorderColor = InputBorderColor,
                        unfocusedBorderColor = InputBorderColor,
                        disabledTextColor = TextColor,
                        focusedBorderColor = BlueApp,
                        cursorColor = BlueApp
                    )
                )
                Row(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.End
                ) {
                    TextButton(
                        modifier = Modifier.pointerHoverIcon(PointerIcon.Hand),
                        onClick = {
                            initialText.value = ""
                            onDismiss()
                        }
                    ) {
                        DisableSelection {
                            Text(
                                fontSize = 14.toScaleSp(),
                                text = stringResource(Res.string.cancel),
                                color = if (initialTextCheck == initialText.value) BlueApp else Color.LightGray
                            )
                        }
                    }
                    Spacer(modifier = Modifier.width(8.toScaleDp()))
                    TextButton(
                        modifier = if (initialTextCheck != initialText.value)
                            Modifier.pointerHoverIcon(PointerIcon.Hand)
                        else Modifier,
                        onClick = {
                            if (initialTextCheck != initialText.value)
                                onConfirm()
                        }
                    ) {
                        DisableSelection {
                            Text(
                                fontSize = 14.toScaleSp(),
                                text = stringResource(Res.string.ok).uppercase(),
                                color = if (initialTextCheck != initialText.value) BlueApp else Color.LightGray
                            )
                        }
                    }
                }
            }
        }
    }
}

@Composable
fun AppInputFieldWithUpdate(
    note: Note,
    onNoteChange: (Note) -> Unit,
    label: String,
    placeholder: String,
    modifier: Modifier = Modifier,
    enabled: Boolean = true,
    onNoteDeleted: () -> Unit
) {

    var showDeleteNotePopup by rememberSaveable { mutableStateOf(false) }

    Row(
        modifier = modifier
            .fillMaxWidth()
            .padding(top = 10.toScaleDp()),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.SpaceAround,
    ) {
        OutlinedTextField(
            modifier = Modifier.weight(2f),
            value = note.noteText.orEmpty(),
            textStyle = TextStyle(fontSize = 14.toScaleSp()),
            onValueChange = { newText ->
                if (enabled) {
                    onNoteChange(note.copy(noteText = newText))
                }
            },
            label = {
                Text(
                    text = label,
                    fontSize = 14.toScaleSp(),
                    color = if (enabled) TextColor else Color.Gray
                )
            },
            placeholder = {
                Text(
                    text = placeholder,
                    fontSize = 14.toScaleSp(),
                    color = if (enabled) TextColor else Color.Gray
                )
            },
            enabled = enabled
        )

        IconButton(
            modifier = Modifier
                .padding(all = 4.dp)
                .pointerCursorIfEnabled(true),
            onClick = {
                showDeleteNotePopup = true
            }) {
            DisableSelection {
                Image(
                    painter = painterResource(Res.drawable.trash),
                    contentDescription = null,
                    modifier = Modifier.size(20.toScaleDp())
                )
            }
        }

    }

    if (showDeleteNotePopup) {
        PopUpDialog(
            title = stringResource(Res.string.confirmation),
            message = stringResource(Res.string.are_you_sure_note),
            onDismiss = { showDeleteNotePopup = false },
            negativeBtnText = stringResource(Res.string.cancel),
            onNegativeBtnClicked = { showDeleteNotePopup = false },
            positiveBtnText = stringResource(Res.string.delete),
            onPositiveBtnClicked = {
                onNoteDeleted()
                showDeleteNotePopup = false
            }
        )
    }
}

@Composable
fun StatusBadge(status: String) {
    Box(
        modifier = Modifier.background(
            StatusColor.getStatusColor(status).copy(alpha = 0.1f),
            RoundedCornerShape(8.toScaleDp())
        )
            .width(125.toScaleDp()).height(35.toScaleDp())
            .padding(horizontal = 8.toScaleDp(), vertical = 4.toScaleDp())
    ) {
        Row(
            modifier = Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.SpaceBetween,
            verticalAlignment = Alignment.CenterVertically
        ) {
            Text(text = status, fontSize = 16.toScaleSp(), color = Color.Black)
            Box(
                modifier = Modifier
                    .size(16.toScaleDp())
                    .background(
                        color = StatusColor.getStatusColor(status),
                        shape = CircleShape
                    )
            )
        }
    }
}

@Composable
fun JobScheduleSection(
    job: Job
) {
    Card(
        modifier = Modifier.fillMaxWidth(),
        shape = RoundedCornerShape(8.toScaleDp()),
        colors = CardDefaults.cardColors(containerColor = Color.White)
    ) {
        Column(modifier = Modifier) {
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(vertical = 8.toScaleDp()),
                verticalAlignment = Alignment.CenterVertically
            ) {
                Column(modifier = Modifier.weight(1f)) {
                    Text(
                        stringResource(Res.string.job_schedule),
                        fontWeight = FontWeight.Bold,
                        fontSize = 20.toScaleSp(),
                        maxLines = 1,
                        overflow = TextOverflow.Ellipsis
                    )
                    Spacer(modifier = Modifier.height(25.toScaleDp()))
                    Row {
                        Column {
                            Text(
                                stringResource(Res.string.start_date),
                                color = Color.Black,
                                fontWeight = FontWeight.Bold,
                                fontSize = 16.toScaleSp(),
                                modifier = Modifier.padding(bottom = 12.toScaleDp()),
                                maxLines = 1,
                                overflow = TextOverflow.Ellipsis
                            )
                            Text(
                                DateTimeUtil.formatJobDetailsDate(job.startDate ?: ""),
                                fontSize = 16.toScaleSp()
                            )
                        }
                        Spacer(modifier = Modifier.width(20.toScaleDp()))
                        Column {
                            Text(
                                stringResource(Res.string.time),
                                color = Color.Black,
                                fontWeight = FontWeight.Bold,
                                fontSize = 16.toScaleSp(),
                                modifier = Modifier.padding(bottom = 12.toScaleDp()),
                                maxLines = 1,
                                overflow = TextOverflow.Ellipsis
                            )
                            Text(
                                "${job.start_at ?: ""} - ${job.end_at ?: ""}".trim()
                                    .takeIf { it != "-" } ?: "",
                                maxLines = 1,
                                fontSize = 16.toScaleSp(),
                                overflow = TextOverflow.Ellipsis
                            )
                        }
                    }
                    Spacer(modifier = Modifier.height(8.toScaleDp()))

                }

                Divider(
                    modifier = Modifier
                        .width(1.toScaleDp())
                        .height(100.toScaleDp())
                        .background(BorderColor)
                )

                Spacer(modifier = Modifier.width(50.toScaleDp()))
                Column(
                    modifier = Modifier.weight(1f),
                    horizontalAlignment = Alignment.Start
                ) {
                    Text(
                        stringResource(Res.string.deadline_and_duration),
                        fontWeight = FontWeight.Bold,
                        fontSize = 20.toScaleSp(),
                        maxLines = 1,
                        overflow = TextOverflow.Ellipsis
                    )
                    Spacer(modifier = Modifier.height(25.toScaleDp()))
                    Row {
                        Column {
                            Text(
                                stringResource(Res.string.due_date),
                                color = Color.Black,
                                fontWeight = FontWeight.Bold,
                                fontSize = 16.toScaleSp(),
                                modifier = Modifier.padding(bottom = 12.toScaleDp()),
                                maxLines = 1,
                                overflow = TextOverflow.Ellipsis
                            )
                            Text(
                                DateTimeUtil.formatJobDetailsDate(job.dueDate ?: ""),
                                maxLines = 1,
                                fontSize = 16.toScaleSp(),
                                overflow = TextOverflow.Ellipsis
                            )
                        }
                    }
                    Spacer(modifier = Modifier.height(8.toScaleDp()))
                }
            }
        }
        Divider(
            color = GrayBackgroundDivider,
            thickness = 4.toScaleDp(),
        )
    }
}


@Composable
fun ContactDetailsSection(
    contact: Contact
) {
    Card(
        modifier = Modifier.fillMaxWidth(),
        shape = RoundedCornerShape(8.toScaleDp()),
        colors = CardDefaults.cardColors(containerColor = Color.White)
    ) {
        Column {
            Text(
                stringResource(Res.string.contact_and_site_details),
                fontWeight = FontWeight.Bold,
                fontSize = 20.toScaleSp(),
                maxLines = 1,
                overflow = TextOverflow.Ellipsis
            )

            Row(modifier = Modifier.padding(top = 24.toScaleDp())) {
                Column {
                    Column {
                        Text(
                            stringResource(Res.string.contact_name),
                            fontWeight = FontWeight.Bold,
                            fontSize = 16.toScaleSp()
                        )
                        Spacer(modifier = Modifier.height(12.toScaleDp()))
                        Text(
                            contact.name ?: "", color = BlueApp, fontSize = 16.toScaleSp(),
                            maxLines = 1,
                            overflow = TextOverflow.Ellipsis
                        )
                    }

                    Spacer(modifier = Modifier.height(24.toScaleDp()))

                    Column {
                        Text(
                            stringResource(Res.string.phone),
                            fontWeight = FontWeight.Bold,
                            fontSize = 16.toScaleSp(),
                            maxLines = 1,
                            overflow = TextOverflow.Ellipsis
                        )
                        Spacer(modifier = Modifier.height(12.toScaleDp()))
                        Text(
                            contact.phone ?: "",
                            maxLines = 1,
                            fontSize = 16.toScaleSp(),
                            overflow = TextOverflow.Ellipsis
                        )
                    }
                }

                Spacer(modifier = Modifier.width(40.toScaleDp()))

                Column {
                    Column {
                        Text(
                            stringResource(Res.string.contact_person),
                            fontWeight = FontWeight.Bold,
                            fontSize = 16.toScaleSp(),
                            maxLines = 1,
                            overflow = TextOverflow.Ellipsis
                        )
                        Spacer(modifier = Modifier.height(12.toScaleDp()))
                        Text(
                            contact.personName ?: "", fontSize = 16.toScaleSp(),
                            maxLines = 1,
                            overflow = TextOverflow.Ellipsis
                        )
                    }
                    Spacer(modifier = Modifier.height(24.toScaleDp()))
                    Column {
                        Text(
                            stringResource(Res.string.email_capital), fontWeight = FontWeight.Bold,
                            maxLines = 1,
                            fontSize = 16.toScaleSp(),
                            overflow = TextOverflow.Ellipsis
                        )
                        Spacer(modifier = Modifier.height(12.toScaleDp()))
                        Text(
                            contact.email ?: "", color = BlueApp,
                            maxLines = 1,
                            fontSize = 16.toScaleSp(),
                            overflow = TextOverflow.Ellipsis
                        )
                    }
                }
            }
        }
    }
}

@Composable
fun CompletionReportImageList(
    items: List<Pair<String, BitmapPainter>>,
    onOpenImageClick: (BitmapPainter) -> Unit
) {
    LazyRow(
        horizontalArrangement = Arrangement.spacedBy(10.toScaleDp()),
        modifier = Modifier.fillMaxWidth()
    ) {
        items(items) { (name, image) ->
            Column(
                modifier = Modifier.width(190.toScaleDp()),
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                Image(
                    painter = image,
                    contentDescription = name,
                    modifier = Modifier
                        .size(190.toScaleDp())
                        .clip(RoundedCornerShape(8.toScaleDp()))
                        .clickableWithPointer {
                            onOpenImageClick(image)
                        },
                    contentScale = ContentScale.Crop
                )
                Spacer(modifier = Modifier.height(4.toScaleDp()))

                Text(
                    text = name,
                    style = MaterialTheme.typography.body2,
                    color = Color.Gray,
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis
                )
            }
        }
    }
}